import { render, staticRenderFns } from "./AdminAuditsData.vue?vue&type=template&id=6619382f&scoped=true&"
import script from "./AdminAuditsData.vue?vue&type=script&lang=js&"
export * from "./AdminAuditsData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6619382f",
  null
  
)

export default component.exports